import { useEffect, useMemo, useRef, useState, useContext } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import axios from '../../axios';
import { Menu, Paper, Button,Text } from '@mantine/core';
import { saveAs } from 'file-saver'; // Import file-saver
import * as XLSX from 'xlsx'; // Import xlsx
import AuthContext from '../../AuthContext';
import { useNavigate } from 'react-router-dom';
const Example = ({ updateProductModalSetting, handlePageUpdate }) => {
  const { centre, userType } = useContext(AuthContext);
  const [paid,setPaid]=useState('')
  // console.log(centre)
  const [balance,setBalance]=useState('')
  const[expense,setExpense]=useState('')
const  navigate=useNavigate()
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatCurrency = (value) => {
    if (isNaN(value)) return value; // In case value is not a number, return it as-is
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    }).format(value);
  };
  
  const columns = useMemo(() => {
    const cols = [
      {
        accessorKey: 'index',
        header: '#',
        size: 50,
        Cell: ({ row }) => row.index + 1,
        visible: true,
      },
      {
        accessorKey: 'head',
        header: 'Head',
        size: 100,
        visible:true,
      },
      {
        accessorKey: 'total_payble',
        header: 'Payable',
        size: 150,
        Cell: ({ cell }) => formatCurrency(cell.getValue()), // Already formatted as number
        visible: true,
      },
      {
        accessorKey: 'total_paid',
        header: 'Paid',
        size: 150,
        Cell: ({ cell }) => formatCurrency(cell.getValue()), // Already formatted as number
        visible: true,
      },
      {
        accessorKey: 'total_expenses',
        header: 'Expenses',
        size: 150,
        Cell: ({ cell }) => formatCurrency(cell.getValue()), // Already formatted as number
        visible: true,
      },
      {
        accessorKey: 'Balance',
        header: 'Balance',
        size: 150,
        Cell: ({ cell }) => formatCurrency(cell.getValue()), // Already formatted as number
        visible: true,
      },
    ];
  
    if (userType === 'Superadmin'||userType==='Accounts') {
      cols.splice(1, 0, {
        accessorKey: 'centre_name',
        header: 'Centre Name',
        size: 200,
        visible: true,
      });
    }
  
    return cols;
  }, [userType]);
  

  const rowVirtualizerInstanceRef = useRef(null);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sorting, setSorting] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState(columns);

  useEffect(() => {
    axios.post('/ledger/getAll', {
      centre_id: centre,
    })
      .then((res) => {
        // console.log(res.data)
        const convertedData = res.data.individualData.map(item => ({
          ...item,
          payble: Number(item.payble), // Convert to number
          expenses: Number(item.expenses), // Convert to number
          balance: Number(item.balance), // Convert to number
        }));
        setData(res.data.individualData);
        setPaid(res.data.aggregateData.total_paid)
        setExpense(res.data.aggregateData.total_expenses)
        setBalance(res.data.aggregateData.total_balance)

      })
      .catch((err) => {console.log(err)
       
      })
      .finally(() => setIsLoading(false));
  }, [handlePageUpdate, centre]);

  useEffect(() => {
    try {
      rowVirtualizerInstanceRef.current?.scrollToIndex(0);
    } catch (e) {
      console.log(e);
    }
  }, [sorting]);

  const table = useMantineReactTable({
    data,
    columns: visibleColumns,
    enableGlobalFilter: true,
    enableColumnFilterModes: true,
    enablePinning: true,
    enablePagination: true,
    enableMultiSort: true, 
    columnFilterDisplayMode:"popover",
    paginationDisplayMode:"pages",
    positionToolbarAlertBanner:"bottom",
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnSelection: true,
    enableGlobalFilter: true,
    enableGlobalFilterModes: true,
    enableStickyHeader: true,
    enableColumnSticky: true,
    enableRowNumbers: true,
    enableRowActions: true,
    renderRowActionMenuItems: ({ row }) => (
      <>
        <Menu.Item onClick={() => updateProductModalSetting(row.original)}>Add Transactions</Menu.Item>
        <Menu.Item onClick={() => navigate(
          `/ledger/details`,{
            state: {centre_id:row.original.centre_id},
          },
          { replace: true }
        )}>Details</Menu.Item>
      </>
    ),
    onColumnVisibilityChange: (visible) => {
      setVisibleColumns(columns.map(col => ({
        ...col,
        visible: visible[col.accessorKey] !== false
      })));
    },
  });

  const handleExport = () => {
    const filteredColumns = visibleColumns.filter(col => col.visible);
    const ws = XLSX.utils.json_to_sheet(data.map((item, index) => {
      return filteredColumns.reduce((acc, col) => {
        acc[col.header] = col.accessorKey === 'index' ? index + 1 : item[col.accessorKey];
        return acc;
      }, {});
    }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'Ledger.xlsx');
  };

  return (
    <Paper shadow="sm" p="lg" withBorder>
      {/* <div className="flex justify-between items-center mb-4">
        <Button color="green" 
        
        onClick={handleExport}>
          Export to Excel
        </Button>
      </div> */}
  {(userType==='Superadmin'||userType==='Accounts')&& (<>
    <div style={{width: '100%' }}>
  {/* Display the total paid and balance amounts */}
  <div style={{ 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    marginBottom: '16px' 
  }}>
    <Text size="md" weight={500} mb="md" mt="0">
      {/* Total Paid aligned to the left */}
      <span className='text-green-600'>Total Paid<hr/> <p className='text-2xl'>{formatCurrency(paid)}</p></span>
    </Text>

    <Text size="md" weight={500} mb="md" mt="0">
      {/* Total Balance aligned to the right */}
      <span className='text-red-600'>Total Balance <hr/><p className='text-2xl'>{formatCurrency(balance)}</p></span>
    </Text>
  </div>
</div>
  </>)}
      <div style={{width: '100%' }}>  
{/* Display the total paid amount */}
      <MantineReactTable
        table={table}
        striped // Enables the striped rows
        highlightOnHover
        fontSize="sm"
        withColumnBorders 
        borderRadius="md"
        withGlobalFilter
        loading={isLoading}
        enableRowSelection={true} // Enables row selection
        enableColumnSelection={true} // Enables column selection
        rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
        enablePagination={true} // Enables pagination
      />
      </div>
    </Paper>
  );
}

export default Example;
